<template>
    <div class="container">
        <loading-animation v-if="loading" minHeight="700" />
        <div v-else>
            <Form ref="info" :labelWidth="120">
                <!-- 合同信息 -->
                <contract-info
                    v-model="contract"
                    prop="contract"
                    :type="routerType"
                    class="contract-content-class"
                />
                <Divider />
                <!-- 租客信息 -->
                <customer-info
                    v-model="cus"
                    prop="cus"
                    :type="routerType"
                    class="contract-content-class"
                    :isShowEditBtn="false"
                    :contractId="contract.id"
                    :houseName="contract.houseName"
                    disabledCusType
                    disabledUser
                    :cusMobileReadOnly="true"
                    :cusSourceReadOnly="true"
                />
                <Divider />
                <!-- 租约信息 -->
                <lease-info
                    v-model="lease"
                    prop="lease"
                    :type="routerType"
                    :leaseLeftAmountText="leaseLeftAmountText"
                    class="contract-content-class"
                    @on-create-bills="createBill"
                />
                <!-- 账单信息 -->
            </Form>
            <Divider />
            <bills-info
                :value="billView"
                class="contract-content-class"
                :loading="billLoading"
            />
            <div style="height: 100px"></div>
            <div class="btn-container">
                <Button
                    style="margin-right: 10px"
                    @click="submit"
                    type="primary"
                    >确定提交</Button
                >
                <Button @click="view">预览合同</Button>
            </div>
        </div>

        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showBillCorrection"
            title="账单修正"
            :width="1080"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="confirmBill"
        >
            <bill-correction v-if="modal.showBillCorrection" v-model="bills" />
        </smart-modal>
    </div>
</template>

<script>
import { deepCopy, currency, officePreview } from '_u/helper'
import { formateContractAndView } from '_v/common/u-contract'
import mContract from '_v/common/m-contract'
import Dict from '_u/dict'

import ContractInfo from './children/contract-info'
import CustomerInfo from './children/customer-info'
import LeaseInfo from './children/lease-info'
import BillsInfo from './children/bills-info'
import BillCorrection from './bill-correction'
import LoadingAnimation from '_v/components/loading-animation'

import { assetsHouseView } from '@/api/assets'
import { contractView, contractPriview, contractRelet } from '@/api/contract'

export default {
    name: 'ContractRenewal',
    mixins: [mContract],
    components: {
        ContractInfo,
        CustomerInfo,
        LeaseInfo,
        BillsInfo,
        BillCorrection,
        LoadingAnimation,
    },
    data() {
        return {
            loading: false,
            billLoading: false, // 生成账单loading
            id: this.$route.params.id,
            contract: {}, // 合同信息
            cus: {}, // 租客信息
            lease: {}, // 租约信息
            facility: [], // 合同设施
            bills: [], // 账单信息
            payBills: [], // 待付账单——存储待付账单——账单修正不显示，创建合同需要合并到bills
            billInfo: [], // 账单信息——账单修正
            billView: [], // 账单信息——账单显示

            room: '', // 房间信息
            dict: {
                feeType: Dict.NULL,
            },
            modal: {
                showBillCorrection: false,
            },
            formData: '',
            from: 'contractIndex',
            routerContractId: this.$route.query.contractId, // 合同id
            routerType: this.$route.query.type, // 合同操作类型 CONTRACT_SCENE
            leaseLeftAmountText: '', // 其他押金与常规押金进行拼接字符串
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true
            let viewData = {}
            // 如果是续住，请求原来合同的信息
            Promise.all([
                contractView(this.routerContractId),
                Dict.get(['fee_type']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    viewData = view
                    return assetsHouseView(view.data.entity.houseId)
                })
                .then((res) => {
                    viewData.data.contractLease.minPrice =
                        res.data.entity.minPrice
                    this.formateView(viewData)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 格式化view数据,获取最小单价值
        formateView(view) {
            const {
                entity,
                contractCus,
                facilityList,
                changeInfo,
                contractLease,
                leftList,
            } = view.data
            // 合同
            this.contract = {
                houseId: entity.houseId,
                houseName: entity.houseName,
                id: entity.id,
            }
            // 客户
            Object.keys(contractCus).forEach((name) => {
                contractCus[name] = contractCus[name] || ''
            })
            this.cus = contractCus
            // 租约
            facilityList.forEach((v) => {
                v.parentId = v.pid
                v.price /= 100
            })
            // 续租，开始日期默认为原合同截止日期的下一天
            const startDate = new Date(contractLease.endDate)
            startDate.setDate(startDate.getDate() + 1)

            contractLease.otherFee =
                JSON.safeParse(contractLease.otherFee) || []
            contractLease.otherFee.forEach((v) => (v.amount /= 100))
            contractLease.otherDeposit =
                JSON.safeParse(contractLease.otherDeposit) || []
            contractLease.otherDeposit.forEach((v) => (v.amount /= 100))

            this.lease = {
                otherFee: contractLease.otherFee,
                otherDeposit: contractLease.otherDeposit,
                fList: facilityList,
                buildArea: contractLease.buildArea,
                unitPrice: contractLease.unitPrice / 100 || '',
                rent: contractLease.rent / 100 || '',
                leftAmount: contractLease.deposit / 100 || '',
                addAmount: contractLease.addAmount / 100 || '',
                minPrice: contractLease.minPrice / 100 || '',
                deposit: contractLease.deposit / 100 || '',
                receiveRentType: contractLease.receiveRentType,
                receiveRentValue: contractLease.receiveRentValue,
                depositPayMethod: contractLease.depositPayMethod,
                rentPayMethod: contractLease.rentPayMethod,
                attachments: contractLease.attachments,
                startDate,
            }
            // 原合同结转金额=常规押金+其它押金列表
            let totalDeposit = 0
            let leftAmountTextArr = []
            const feeTypeDict = this.dict.feeType
            leftList.forEach((v) => {
                totalDeposit += v.realAmount / 100 || 0
                leftAmountTextArr.push(
                    `${feeTypeDict.val(v.feeType)} ${currency(
                        v.realAmount / 100 || 0
                    )}`
                )
            })
            this.leaseLeftAmountText = `${currency(
                totalDeposit
            )}(${leftAmountTextArr.join(',')})`
        },

        // 提交-显示修改账单
        submit() {
            this.$refs.info
                .validate()
                .then(() => {
                    this.modal.showBillCorrection = true
                })
                .catch((err) => {
                    this.$Message.error(err[0].message)
                })
        },
        // 预览合同
        view() {
            this.$refs.info
                .validate()
                .then(() => {
                    const data = deepCopy(this.$refs.info.populateData())
                    // deposit没有地方显示，数据采集采集不到，续租有原合同结转金额，押金置为零
                    data.lease.deposit = 0

                    formateContractAndView(data)
                    data.bills = deepCopy(this.bills.concat(this.payBills))
                    data.bills.forEach((v) => {
                        v.title = ''
                        v.periodText = ''
                        v.bill = ''
                    })

                    const formData = {
                        contract: JSON.stringify(data.contract),
                        cus: JSON.stringify(data.cus),
                        lease: JSON.stringify(data.lease),
                        facility: JSON.stringify(data.facility),
                        bills: JSON.stringify(data.bills),
                    }
                    contractPriview(formData).then((res) => {
                        window.open(officePreview(res.data.path))
                    })
                })
                .catch((err) => {
                    this.$Message.error(err[0].message)
                })
        },
        // 创建账单
        createBill() {
            const formData = deepCopy(this.$refs.info.populateData().lease)
            if (!formData) return
            // deposit没有地方显示，数据采集采集不到，生成账单不含
            formData.deposit = 0
            this.createContractBill(formData)
        },
        // 续租
        contractCreate() {
            const data = deepCopy(this.$refs.info.populateData())
            this.formatePopulateData(data)
            const formData = {
                contractId: this.routerContractId,
                contract: JSON.stringify(data.contract),
                cus: JSON.stringify(data.cus),
                lease: JSON.stringify(data.lease),
                facility: JSON.stringify(data.facility),
                bills: JSON.stringify(data.bills),
                changeType: '3', // 在续租与换房（押金平移）有
            }
            return contractRelet(formData)
        },
        // 格式化
        formatePopulateData(data) {
            // deposit没有地方显示，数据采集采集不到，续租有原合同结转金额，押金置为零
            data.lease.deposit = 0

            formateContractAndView(data)

            data.bills = deepCopy(this.bills.concat(this.payBills))
            data.bills.forEach((v) => {
                v.title = ''
                v.periodText = ''
                v.bill = ''
            })
        },
        // 确认账单
        confirmBill() {
            this.contractCreate().then(() => {
                this.$Message.success('续租成功')
                this.$router.push({
                    name: this.from,
                })
            })
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
}
</style>
